import React from 'react';
import './EventInfo.scss';
import AlertLevel from '../../../../shared/alert-level/AlertLevel';

export const EventInfo = ({ event }) => {
    const {
        friendlyEventType,
        description,
        eventTimestamp,
        eventReference,
        jurisdiction,
        clientBrand,
        playerId,
        username,
        playerCountry,
        playerIp,
        playerRisk
    } = event;

    return (
        <div className={'event-info'}>
            <table className={'event-info-table'}>
                <tbody>
                    <tr>
                        <th>Event Type</th>
                        <td>{friendlyEventType}</td>
                    </tr>
                    <tr>
                        <th>Description</th>
                        <td>{description}</td>
                    </tr>
                    <tr>
                        <th>Event Timestamp</th>
                        <td>{eventTimestamp}</td>
                    </tr>
                    <tr>
                        <th>Event Reference</th>
                        <td>{eventReference}</td>
                    </tr>
                    {jurisdiction && (
                        <tr>
                            <th>Jurisdiction</th>
                            <td>{jurisdiction}</td>
                        </tr>
                    )}
                    {clientBrand && (
                        <tr>
                            <th>Brand</th>
                            <td>{clientBrand.name}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <table className={'event-info-table'}>
                <tbody>
                    <tr>
                        <th>Player Id</th>
                        <td>{playerId}</td>
                    </tr>
                    <tr>
                        <th>Player name</th>
                        <td>{username}</td>
                    </tr>
                    <tr>
                        <th>Player Country</th>
                        <td>{playerCountry}</td>
                    </tr>
                    <tr>
                        <th>Player IP</th>
                        <td>{playerIp}</td>
                    </tr>
                    <tr>
                        <th>Player Average Risk</th>
                        <td>
                            <AlertLevel level={playerRisk.averageRisk} />
                        </td>
                    </tr>
                    <tr>
                        <th>Player AML Risk</th>
                        <td>
                            <AlertLevel level={playerRisk.amlRisk} />
                        </td>
                    </tr>
                    <tr>
                        <th>Player RG Risk</th>
                        <td>
                            <AlertLevel level={playerRisk.rgRisk} />
                        </td>
                    </tr>
                    <tr>
                        <th>Player Fraud Risk</th>
                        <td>
                            <AlertLevel level={playerRisk.fraudRisk} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
